import React, { useEffect, useState } from 'react';
import background from '../images/HomeBackground.png'
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import Sidebar from '../components/sidebar';
import backgroundSm from '../images/BackgroundSm.png'
import { Link } from 'react-router-dom';
import { deleteDoc, doc, getDoc } from "firebase/firestore";
import db from "../firebaseConfig";


function Homepage() {
    const [notice, setNotice] = useState(null)
    useEffect(() => {
      const getNotice = async () => {
        try {
            const docSnap = await getDoc(doc(db, "notices", "notice"))
            if(!docSnap.exists()) {
                return
            }
            const data = docSnap.data()
            console.log(data)
            if(!data) {
                return
            }
            if(data.endTimestamp.toDate() < Date.now()) {
                console.log(data.endTimestamp.toDate())
                console.log(Date.now())
                await deleteDoc(doc(db, "notices", "notice"))
                return
            }
            setNotice(data.text)
        } catch (e) {
            console.log(e)
        }
      }
      getNotice()
    }, [])
    
    return(
        <div className="md:relative">
            <div className='block md:hidden'><Sidebar /></div>
            <div className='hidden md:block min-w-100'><Navbar /></div>
            <div>

                <div className="relative w-full md:mt-24">
                    <img className="hidden md:block w-full object-cover" src={background} alt="background"/>
                    <img className="md:hidden block" src={backgroundSm} alt="background"/>
                    <div id="title-block" className="text-white absolute inset-0 flex flex-col items-center justify-center mb-20">
                        <h1 id="title" className="md:text-8xl text-2xl font-semibold py-5">Bottle Depot</h1>
                        <br></br>
                        <h3 id="subtitle" className="md:text-3xl font-semibold">One Stop to Return all NY Cans &amp; Bottles</h3>
                    </div>
                </div>
                {
                    notice && 
                    <div className="w-full h-40 bg-red-800 text-white drop-shadow-2xl/30 text-center">
                        <p className="text-2xl p-8">NOTICE</p>
                        <p>{notice}</p>
                    </div>
                }
                {/* What We Do Section */}
                <div className="w-full h-auto bg-gray-100 text-center items-center justify-center flex flex-col p-10">
                    <h2 className="font-semibold text-black text-3xl pb-10 pt-5">What We Do</h2>
                    <p className="pb-5 md:w-4/6">
                        We are the leading bottle and can return center in the Hudson Valley. We take all NY 5¢ deposit
                        empties and get your money back to you. There is no longer a need to wait on slow return machines. With returning your bottles and cans, you are
                        doing your part in protecting our environment. Come to a Bottle Depot near you for a fast, clean, and convenient bottle return experience.
                    </p>
                </div>

                {/* Precounts Section */}
                <div className="flex md:flex-row flex-col items-center w-full p-10 py-20">
                    <h2 className='font-semibold text-black text-3xl md:w-4/10 md:text-right pb-10 pt-5'>Precounts</h2>
                    <div className="md:w-1/10 w-0"></div>
                    <p className='md:w-1/2 text-center md:p-10 self-center pb-5'>
                        To make your wait even shorter, we have introduced precounting.
                        You are free to count the returns you bring in beforehand. Please let us know if you have any precounts when you come in.
                        We reserve the right to count any one of your bags for verfication. Please make sure that your bags are labelled with the number of empties on each bag.
                    </p>
                </div>

                {/* Accepted Containers Section */}
                <div className="bg-gray-100 flex flex-col-reverse md:flex-row items-center w-full p-10 md:p-0">
                    <p className=' md:w-2/3 text-center pb-5'>
                        Not all containers are accepted. View a summary of what we accept here.
                    </p>
                    <div className="font-semibold text-black text-3xl md:w-1/2 md:text-left md:p-20 pb-10 pt-5">
                        <h2>Accepted Containers</h2>
                    </div>
                </div>

                {/* Contact Us Section */}
                <div className='flex flex-col md:flex-row items-center w-full'>
                    <h2 className='font-semibold text-black text-3xl md:w-1/2 md:text-right md:p-30 md:mr-40 pb-5 pt-5'>Contact Us</h2>
                    <div className='md:w-1/2 text-center md:p-10 md:mr-50 pb-5'>
                        <p className='p-2'>Need some help? Get in Touch!</p>
                        <button className='bg-blue-600 text-white px-4 py-2 rounded'>
                            <Link to='/contact'>Contact Us</Link>
                        </button>
                    </div>
                </div>

            </div>

            <Footer />
        </div>
    )
}


export default Homepage
